import { render, staticRenderFns } from "./user-order.vue?vue&type=template&id=3557126c&scoped=true"
import script from "./user-order.vue?vue&type=script&lang=js"
export * from "./user-order.vue?vue&type=script&lang=js"
import style0 from "./user-order.vue?vue&type=style&index=0&id=3557126c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557126c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3557126c')) {
      api.createRecord('3557126c', component.options)
    } else {
      api.reload('3557126c', component.options)
    }
    module.hot.accept("./user-order.vue?vue&type=template&id=3557126c&scoped=true", function () {
      api.rerender('3557126c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/user-order.vue"
export default component.exports